import { io } from 'socket.io-client';
import {node_api_url} from "./services/nodeServide";

// "undefined" means the URL will be computed from the `window.location` object
const URL =    node_api_url.replace("api","")
// process.env.NODE_ENV === 'production' ? undefined :
export const socket = io(URL,{
    // auth: {
    //     token: getIdToken(), // aquí se envía
    // },
    autoConnect: false,
    reconnectionDelay: 10000,
    reconnectionAttempts: 4,
});

